import React, { useState } from "react";
import Navbar from "./components/Navbar";
import GameCard from "./components/GameCard";
import LoginModal from "./components/LoginModal";

function App() {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [showLogin, setShowLogin] = useState(false);
  const [loginUser, setLoginUser] = useState("");
  const [loginPass, setLoginPass] = useState("");
  const [pendingGame, setPendingGame] = useState(null);

  const games = [
    {
      id: 1,
      title: "Cyberpunk 2077",
      description: "Cyberpunk 2077 je akční RPG zasazené do Night City.",
      img: "https://cdn.akamai.steamstatic.com/steam/apps/1091500/header.jpg",
    },
    {
      id: 2,
      title: "The Witcher 3: Wild Hunt",
      description: "Staň se Geraltem z Rivie a vydej se hledat Ciri.",
      img: "https://cdn.akamai.steamstatic.com/steam/apps/292030/header.jpg",
    },
  ];

 const handleGiftClick = async (game) => {
  try {
    const res = await fetch("https://click-tracker.spaniklukas.workers.dev/api/click", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action_type: "present" }),
    });
    const data = await res.json();
    console.log("Gift click uložen:", data);

    setPendingGame(game);
    setShowLogin(true);
  } catch (err) {
    console.error("Chyba při ukládání kliknutí:", err);
    alert("❌ Nepodařilo se uložit kliknutí na server");
  }
};

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!loginUser || !loginPass) return;

    setLoading(true);
    try {
      const res = await fetch("https://click-tracker.spaniklukas.workers.dev/api/click", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action_type: "login" }),
      });
      const data = await res.json();
      if (data.success) {
        setMessage(`🎉 Dárek "${pendingGame.title}" převzat!`);
      } else {
        setMessage("Chyba: " + data.error);
      }
    } catch (err) {
      setMessage("❌ Chyba spojení se serverem");
    }

    setLoading(false);
    setShowLogin(false);
    setLoginUser("");
    setLoginPass("");
    setPendingGame(null);
  };

  return (
    <div style={{ backgroundColor: "#1b2838", minHeight: "100vh", color: "#c7d5e0", fontFamily: "sans-serif" }}>
      <Navbar search={search} setSearch={setSearch} />

      <div style={{ padding: "2rem", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {games
          .filter((g) => g.title.toLowerCase().includes(search.toLowerCase()))
          .map((game) => (
            <GameCard key={game.id} game={game} onGiftClick={handleGiftClick} />
          ))}
        <p style={{ marginTop: "1rem", fontStyle: "italic" }}>{message}</p>
      </div>

      {showLogin && (
        <LoginModal
          loginUser={loginUser}
          setLoginUser={setLoginUser}
          loginPass={loginPass}
          setLoginPass={setLoginPass}
          loading={loading}
          onClose={() => setShowLogin(false)}
          onSubmit={handleLogin}
        />
      )}
    </div>
  );
}

export default App;
